import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function RootErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : t("error.boundary");

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-2 bg-background text-foreground">
      <p className="text-sm text-muted-foreground">{message}</p>
      <a href="/" className="text-sm underline underline-offset-2">
        {t("error.backHome")}
      </a>
    </div>
  );
}
